<template>
  <div>
    <h6 class="has-text-weight-bold mt-4 text-base text-gray-500">
      {{ value.label }} :
    </h6>
    <p>
      {{ categoryLabel }}
      <template v-if="subCategoryLabel">
        <i class="fal fa-chevron-right text-xs text-gray-400 mx-1"></i>
        {{ subCategoryLabel }}
      </template>
    </p>
  </div>
</template>

<script>
/**
 * SPDX-FileCopyrightText: © 2021-2026 SAS Cœur du Web, Paris (France) — https://coeurduweb.com
 * SPDX-License-Identifier: LicenseRef-CoeurDuWeb-Proprietary
 *
 * Tous droits réservés. Logiciel propriétaire, non libre.
 * Les conditions d'utilisation, le périmètre de la licence concédée et les
 * restrictions applicables figurent dans le fichier LICENCE.md à la racine du dépôt.
 */
export default {
  name: 'PreviewCategoryAttribute',
  props: ['value'],
  computed: {
    answer() {
      const raw = this.value.value
      return typeof raw === 'object' && raw !== null ? raw : { label: raw }
    },
    categoryLabel() {
      return this.answer.label || ''
    },
    subCategoryLabel() {
      // `sub_category` est la clé de l'API ; `subcategory` a été écrite un temps
      // par le wizard et survit dans les tickets existants.
      return this.answer.sub_category || this.answer.subcategory || null
    }
  }
}
</script>

<style scoped></style>
